/**
 * Module kanban — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "kanban",
  label: "Kanban ateliers",
  icon: "i-grid",
  navGroup: "operations",
  navOrder: 40,
  rolesRequis: [],
  routes: [{ path: "/kanban", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
